import Receipt from '@/components/Receipt';
import receiptConfig from '@/components/Receipt/config';
import type {AfriexAdminTransaction} from '@/types';
import {AfriexTransactionType} from '@/types';
import {capitalizeWords} from '@/utils/dashboard';
import {getFieldsToDisplay} from '@/utils/transactionFormatter';

const TransactionReceipt = ({data}: {data: AfriexAdminTransaction}) => {
  const getReceiptType = () => {
    switch (data.type) {
      case AfriexTransactionType.WITHDRAW:
        return `${capitalizeWords(data.type?.replace(/_/g, ' '))}`;
      case AfriexTransactionType.DEPOSIT:
        return 'Charge';
      case AfriexTransactionType.TRANSFER:
        return `${capitalizeWords(data.type?.replace(/_/g, ' '))} - Fiat`;
      default:
        return `${capitalizeWords(data.type?.replace(/_/g, ' '))} Receipt`;
    }
  };

  let keysToSkip: string[] = [];
  switch (data.type) {
    case AfriexTransactionType.WITHDRAW:
      keysToSkip = ['Tier Id', 'Internal Reference', 'Fee Rule'];
      break;
    case AfriexTransactionType.DEPOSIT:
      keysToSkip = ['Customer Device Id', 'Customer Device Type', 'Fee Rule'];
      break;
    case AfriexTransactionType.TRANSFER:
      keysToSkip = ['Customer Device Id', 'Customer Device Type', 'Fee Rule'];
      break;
    default:
      keysToSkip = ['Fee Rule'];
      break;
  }

  return (
    <Receipt type="transaction" transactionType={data.type} scope={data.id}>
      <div className="main bg-receipt-bg dark:bg-gray-900 p-5 mt-5">
        <p
          className="text-cyan-600 font-medium text-sm mb-3"
          data-cy="admin-receipt-type"
        >
          {getReceiptType()}
        </p>
        <hr className="border-receipt-line dark:border-dark-borderMid" />

        {/* Transaction Details */}
        <div className="contentParent mt-2.5">
          {getFieldsToDisplay(data)?.map((entry, idx) => {
            const key = Object.keys(entry)[0];
            const value = Object.values(entry)[0];

            const modValue = Array.isArray(value) ? value.join(', ') : value;

            if (keysToSkip.includes(key) || !value || value?.length === 0) {
              return null;
            }

            return (
              <div
                key={`${key}-${idx}`}
                className="content flex w-full justify-between my-6"
                // Same `data-field-label` convention as the Details panel.
                data-cy="admin-receipt-field"
                data-field-label={key}
              >
                <p className="contentA text-xs font-medium text-gray-600 dark:text-gray-200 flex-shrink-0 w-2/5">
                  {key}
                </p>
                <p
                  className="contentB text-xs font-semibold text-right text-gray-700 dark:text-gray-100 flex-grow break-words w-full"
                  data-cy="admin-receipt-field-value"
                >
                  {modValue}
                </p>
              </div>
            );
          })}

          {/* receipt checkboxed display */}
          <div className="receipt-checkbox flex items-center">
            <input
              type="checkbox"
              defaultChecked
              disabled
              className="w-4 h-4 appearance-none rounded border border-gray-300 bg-white checked:bg-cyan-600 checked:border-cyan-600 disabled:opacity-70 dark:bg-dark-inputBg dark:border-gray-600 dark:checked:bg-cyan-400 dark:checked:border-cyan-400"
            />
            <span className="text-xs font-medium text-gray-700 dark:text-gray-100 ml-2">
              {receiptConfig.userAcceptancePolicy}
            </span>
          </div>
        </div>
      </div>
    </Receipt>
  );
};

export default TransactionReceipt;
